import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f7b67d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-wrapper" }
const _hoisted_2 = { class: "layout-inner -wide -top-and-bottom" }
const _hoisted_3 = { class: "season-game-content" }
const _hoisted_4 = { class: "season-game-header" }
const _hoisted_5 = { class: "season-group-nav" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全試合")
const _hoisted_8 = { class: "season-game-nav" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = ["aria-selected"]
const _hoisted_11 = {
  key: 0,
  class: "item _pcTabDisp"
}
const _hoisted_12 = ["aria-selected"]
const _hoisted_13 = {
  key: 1,
  class: "item _pcTabDisp"
}
const _hoisted_14 = ["aria-selected"]
const _hoisted_15 = ["aria-hidden"]
const _hoisted_16 = ["aria-hidden"]
const _hoisted_17 = ["aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Schedule = _resolveComponent("Schedule")!
  const _component_League = _resolveComponent("League")!
  const _component_Tournament = _resolveComponent("Tournament")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "link",
                "data-is-active": !_ctx.$route.query.group,
                to: {
                  name: 'seasonGame',
                  query: { custom: _ctx.$route.query.custom } }
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["data-is-active", "to"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.custom?.groups, (group) => {
              return (_openBlock(), _createElementBlock("li", {
                key: group.id,
                class: "item"
              }, [
                _createVNode(_component_router_link, {
                  class: "link",
                  "data-is-active": _ctx.$route.query.group == group.id,
                  to: {
                  name: 'seasonGame',
                  query: { custom: _ctx.$route.query.custom, group: group.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(group.name), 1)
                  ]),
                  _: 2
                }, 1032, ["data-is-active", "to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "link",
              "aria-controls": "schedule",
              "aria-selected": _ctx.gameTab.id === 'schedule' ? 'true' : 'false',
              role: "tab",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeGameTabPanel && _ctx.changeGameTabPanel(...args)))
            }, "日程", 8, _hoisted_10)
          ]),
          (_ctx.customMatchType === 'league')
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "link",
                  "aria-controls": "league",
                  "aria-selected": _ctx.gameTab.id === 'league' ? 'true' : 'false',
                  role: "tab",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeGameTabPanel && _ctx.changeGameTabPanel(...args)))
                }, "リーグ", 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          (_ctx.customMatchType === 'tournament')
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "link",
                  "aria-controls": "tournament",
                  "aria-selected": _ctx.gameTab.id === 'tournament' ? 'true' : 'false',
                  role: "tab",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeGameTabPanel && _ctx.changeGameTabPanel(...args)))
                }, "トーナメント", 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          id: "schedule",
          class: "season-game-panel",
          "aria-hidden": _ctx.gameTab.id !== 'schedule',
          role: "tabpanel"
        }, [
          _createVNode(_component_Schedule, {
            groups: _ctx.groups,
            fields: _ctx.fields,
            isMobile: _ctx.mediaQuery.isMobile
          }, null, 8, ["groups", "fields", "isMobile"])
        ], 8, _hoisted_15),
        (_ctx.customMatchType === 'league')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "league",
              class: "season-game-panel",
              "aria-hidden": _ctx.gameTab.id !== 'league',
              role: "tabpanel"
            }, [
              (_ctx.gameTab.id === 'league')
                ? (_openBlock(), _createBlock(_component_League, { key: 0 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_16))
          : _createCommentVNode("", true),
        (_ctx.customMatchType === 'tournament')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "tournament",
              class: "season-game-panel",
              "aria-hidden": _ctx.gameTab.id !== 'tournament',
              role: "tabpanel"
            }, [
              (_ctx.gameTab.id === 'tournament')
                ? (_openBlock(), _createBlock(_component_Tournament, { key: 0 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}